import {colors} from '../colors/colors';
import type {DripSequenceStatus} from '../edition/get-edition-status-info';

export const getDripSequenceTriggerColor = (status: DripSequenceStatus) => {
    let color: string = colors.offWhiteDk;

    switch (status) {
        case 'ACTIVE':
            color = colors.greenDk;
            break;
        case 'DRAFT':
            color = colors.blue;
            break;
        case 'PAUSED':
            color = colors.orangeAttention;
            break;
    }

    return color;
};
